<div #toastOutlet></div>

<app-modal
  #deleteModal
  label="Delete Candidate"
  description="Are you sure you want to delete this candidate? This action cannot be undone."
  (confirmed)="confirmDelete()" />

<div class="flex">
  <div class="flex min-h-0 flex-col w-full p-6 md:p-11 card">
    <div
      class="flex md:justify-between justify-center md:flex-row flex-col gap-4 mb-4">
      <p
        class="lg:text-4xl text-2xl font-bold"
        data-testid="candidates-page-header">
        Candidates
      </p>
      <app-button
        data-testid="go-to-invite-button"
        id="go-to-invite-button"
        color="primary"
        label="Go to invite"
        routerLink="/invitations/" />
    </div>
    <div class="flex items-center mb-4">
      <div class="relative md:w-72 w-full">
        <input
          data-testid="search-candidate-input"
          id="search-candidate-input"
          type="text"
          name="search"
          placeholder="mail@myorder.ai"
          class="input input-bordered w-full rounded-lg placeholder-gray-300"
          (input)="searchQuery.set($any($event.target).value)" />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 absolute right-3 top-1/2 -translate-y-1/2 text-gray-300"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
    </div>
    <div
      class="overflow-x-auto rounded-box border border-base-content/5 bg-base-100">
      <table class="table" data-testid="candidates-table">
        <thead>
          <tr class="bg-gray-100 text-gray-800">
            <th role="columnheader" name="Email">Email</th>
            <th role="columnheader" name="Test Set">Test Set</th>
            <th role="columnheader" name="Status">Status</th>
            <th role="columnheader" name="Status">Invite Date</th>
            <th role="columnheader" name="Expire Date">Expire Date</th>
            <th role="columnheader" name="Completed time">Completed time</th>
            <th class="text-center" role="columnheader" name="Tools">Tools</th>
          </tr>
        </thead>
        <tbody>
          @if (isCandidatesLoading()) {
          <tr>
            <td colspan="6" class="text-center">
              <span class="loading loading-dots loading-lg"></span>
            </td>
          </tr>
          } @else if (!candidatesData() || filteredCandidates().length === 0) {
          <tr>
            <td
              colspan="7"
              class="text-center text-gray-400"
              data-testid="candidates-empty">
              No candidates found.
            </td>
          </tr>
          } @else { @for (candidate of filteredCandidates(); track
          candidate.invitationId) {
          <tr data-testid="candidate-row">
            <td>{{ candidate.invitedEmail }}</td>
            <td>{{ candidate.title }}</td>
            <td><app-badge [value]="candidate.status" /></td>
            <td>
              {{ candidate.scheduledAt ? (candidate.scheduledAt | date: `dd MMM
              yyyy, hh:mm a`) : '--' }}
            </td>
            <td>
              {{ candidate.expiredAt ? (candidate.expiredAt | date: `dd MMM
              yyyy, hh:mm a`) : '--' }}
            </td>
            <td>
              {{ candidate.completedAt ? (candidate.completedAt | date: `dd MMM
              yyyy, hh:mm a`) : '--' }}
            </td>
            <td class="justify-center flex gap-2">
              <!-- Analyze button -->
              <button
                [attr.data-testid]="'analyze-button'+candidate.invitationId"
                id="analyze-candidate-button"
                [disabled]="!canAnalyze(candidate.status)"
                [class]="analyzeButtonClass(candidate.status)"
                routerLink="/candidates/analyze/{{ candidate.invitationId }}">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.4 21.6001H5.39999C4.0745 21.6001 2.99999 20.5256 3 19.2001L3.00009 4.80013C3.0001 3.47466 4.07462 2.40015 5.40009 2.40015H16.2004C17.5258 2.40015 18.6004 3.47466 18.6004 4.80015V9.60015M19.8 19.8001L21 21.0001M7.20037 7.20015H14.4004M7.20037 10.8001H14.4004M7.20037 14.4001H10.8004M20.4 17.4001C20.4 19.057 19.0569 20.4001 17.4 20.4001C15.7431 20.4001 14.4 19.057 14.4 17.4001C14.4 15.7433 15.7431 14.4001 17.4 14.4001C19.0569 14.4001 20.4 15.7433 20.4 17.4001Z"
                    stroke="#3F3F46"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </button>

              <!-- Delete button -->
              <button
                [attr.data-testid]="'delete-button'+candidate.invitationId"
                id="delete-candidate-button"
                [disabled]="!canDelete(candidate.status)"
                [class]="deleteButtonClass(candidate.status)"
                (click)="onDeleteCandidate(candidate.invitationId)">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17.4163 1.83301H4.58301C3.06422 1.83301 1.83301 3.06422 1.83301 4.58301V6.41634C1.83301 6.9226 2.24341 7.33301 2.74967 7.33301H3.66634V17.4163C3.66634 18.9351 4.89756 20.1663 6.41634 20.1663H15.583C17.1018 20.1663 18.333 18.9351 18.333 17.4163V7.33301H19.2497C19.7559 7.33301 20.1663 6.9226 20.1663 6.41634V4.58301C20.1663 3.06422 18.9351 1.83301 17.4163 1.83301ZM16.4997 17.4163C16.4997 17.9226 16.0893 18.333 15.583 18.333H6.41634C5.91008 18.333 5.49967 17.9226 5.49967 17.4163V7.33301H16.4997V17.4163ZM3.66634 5.49967H18.333V4.58301C18.333 4.07675 17.9226 3.66634 17.4163 3.66634H4.58301C4.07675 3.66634 3.66634 4.07675 3.66634 4.58301V5.49967ZM7.33301 15.583V10.083C7.33301 9.57675 7.74341 9.16634 8.24967 9.16634C8.75594 9.16634 9.16634 9.57675 9.16634 10.083V15.583C9.16634 16.0893 8.75594 16.4997 8.24967 16.4997C7.74341 16.4997 7.33301 16.0893 7.33301 15.583ZM12.833 10.083V15.583C12.833 16.0893 13.2434 16.4997 13.7497 16.4997C14.2559 16.4997 14.6663 16.0893 14.6663 15.583V10.083C14.6663 9.57675 14.2559 9.16634 13.7497 9.16634C13.2434 9.16634 12.833 9.57675 12.833 10.083Z"
                    fill="#3F3F46" />
                </svg>
              </button>
            </td>
          </tr>
          } }
        </tbody>
      </table>
    </div>
  </div>
</div>
